import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Choose a new password" subtitle={token ? "Enter and confirm your new password." : "This reset link is missing its token."}>
      {done ? (
        <div className="space-y-4">
          <div data-testid="reset-success" className="rounded-md border border-teal-500/40 bg-teal-500/10 px-3 py-2 text-sm">Password updated. You can sign in now.</div>
          <Link data-testid="reset-login-link" to="/login" className="block text-center text-sm text-primary hover:underline">Go to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <label className="block"><span className="overline-label">New password</span>
            <input data-testid="reset-password-input" className="field-input mt-1 h-9" type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={8} required autoFocus /></label>
          <label className="block"><span className="overline-label">Confirm password</span>
            <input data-testid="reset-confirm-input" className="field-input mt-1 h-9" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength={8} required /></label>
          {error && <div data-testid="reset-error" className="rounded-md border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm text-red-600 dark:text-red-300">{error}</div>}
          <Button data-testid="reset-submit-button" type="submit" className="w-full h-9" disabled={busy || !token}>{busy ? "Saving…" : "Set new password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
